import {Component, Host, h, Prop, Element} from '@stencil/core';

@Component({
  tag: 'me-link',
  styleUrl: 'me-link.scss',
  shadow: false,
})
export class MeLink {

  private static nextLinkID = 1;
  private readonly linkID = MeLink.nextLinkID++;

  @Element() host: HTMLElement;

  @Prop() theme = 'primary';
  @Prop({ reflect: true }) href?: string;
  @Prop() target = '_self';
  @Prop() rel?: string;
  @Prop() download?: string;

  private hasIcon = false;

  componentWillLoad() {
    this.hasIcon = Boolean(this.host.querySelector('[slot="icon-left"], [slot="icon-right"]'));
  }

  render() {
    const labelID = `me-link-label-${this.linkID}`;

    const classList = [
      'me-link',
      `me-link--${this.theme}`,
      this.hasIcon ? 'me-link--has-icon' : null,
    ].filter(c => !!c).join(' ');

    return (
      <Host class={classList}>
        <a
          class="me-link__anchor"
          href={this.href}
          rel={this.rel}
          target={this.target}
          aria-labelledby={labelID}
          download={this.download}
        >
          <span class="me-link__icon me-link__icon--left">
            <slot name="icon-left"></slot>
          </span>
          <span id={labelID} class="me-link__label">
            <slot></slot>
          </span>
          <span class="me-link__icon me-link__icon--right">
            <slot name="icon-right"></slot>
          </span>
        </a>
      </Host>
    );
  }

}
